/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_List_Delete_ConfirmInputs */

const cs_property_list_delete_confirm = /** @type {(inputs: Property_List_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opravdu smazat tuto nemovitost? Nejdřív se odebere ze všech zapnutých portálů. Tuto akci nelze vrátit.`)
};

const en_property_list_delete_confirm = /** @type {(inputs: Property_List_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this property? It will be removed from all enabled portals first. This cannot be undone.`)
};

/**
* | output |
* | --- |
* | "Delete this property? It will be removed from all enabled portals first. This cannot be undone." |
*
* @param {Property_List_Delete_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_list_delete_confirm = /** @type {((inputs?: Property_List_Delete_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_List_Delete_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_list_delete_confirm(inputs)
	return cs_property_list_delete_confirm(inputs)
});